// Room codes (docs/plans/2026-10-18-date-raho.md, section 7): a room of friends is found by a short code carried in an
// invite link, never by matchmaking. The alphabet leaves out the letters and digits that read alike (0/o, 1/l/i).
export const CODE_ALPHABET = 'abcdefghjkmnpqrstuvwxyz23456789';
export const CODE_LEN = 6;
const CODE_RE = new RegExp(`^[${CODE_ALPHABET}]{${CODE_LEN}}$`);

/** a code as typed or pasted, lower-cased and trimmed; null unless it is well formed */
export function cleanRoomCode(raw: unknown): string | null {
  if (typeof raw !== 'string') return null;
  const c = raw.trim().toLowerCase();
  return CODE_RE.test(c) ? c : null;
}

/** a fresh code; `rnd` returns [0, 1) */
export function newRoomCode(rnd: () => number = Math.random): string {
  let c = '';
  for (let i = 0; i < CODE_LEN; i++) c += CODE_ALPHABET[Math.floor(rnd() * CODE_ALPHABET.length)];
  return c;
}
